<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易管理</el-breadcrumb-item>
      <el-breadcrumb-item>山海经红包提现信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-input size="small" v-model="queryField.cashoutId" placeholder="记录id"></el-input>
        <el-input size="small" v-model="queryField.userId" placeholder="用户id"></el-input>
        <el-select size="small" v-model="queryField.status">
          <el-option label="待审核" value="1"></el-option>
          <el-option label="已审核" value="2"></el-option>
          <el-option label="已发放" value="3"></el-option>
          <el-option label="废弃" value="4"></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="loadData(1)">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </el-row>
      <el-table class="cps-table-data"
                :data="tableData"
                size="small"
                border
                v-loading="tableLoading"
                :height="height"
                style="width: 100%"
                id="rebateSetTable">
        <el-table-column
            prop="cashout_id"
            width="80"
            label="id">
        </el-table-column>
        <el-table-column
            prop="user_id"
            width="80"
            label="用户id">
        </el-table-column>
          <el-table-column
              prop="rechargeAmount"
              width="100"
              label="充值金额">
          </el-table-column>
        <el-table-column
            prop="cashout_money"
            width="100"
            label="提现金额">
        </el-table-column>
        <el-table-column
            prop="cashout_des"
            width="180"
            label="描述">
        </el-table-column>
        <el-table-column
            prop="status"
            width="80"
            :formatter="formatterStatus"
            label="发放状态">
        </el-table-column>
        <el-table-column
            prop="add_time"
            width="150"
            label="提现时间">
        </el-table-column>
        <el-table-column>
          <template v-slot="scope">
            <el-button type="text" size="small" v-if="scope.row.status === 1" @click="updateAuditStatus(scope.row.cashout_id)">通过审核</el-button>
            <el-button type="text" size="small" v-if="scope.row.status === 2" @click="updateGrantStatus(scope.row.cashout_id)">已发放</el-button>
            <el-button type="text" size="small" v-if="scope.row.status === 1" @click="updateDiscardStatus(scope.row.cashout_id)">废弃</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--底部分页-->
      <el-pagination class="cps-table-data"
                     @current-change="loadData"
                     background
                     :page-size="15"
                     :current-page="currentIndex"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {queryShjRedCashout, updateAuditStatus, updateDiscardStatus, updateGrantStatus} from "@/api/request";

export default {
  name: "shjRedCashout",
  data(){
    return {
      queryField: {
        cashoutId: "",
        userId: "",
        status: ""
      },
      tableData: [],
      tableLoading: false,
      height: window.innerHeight - 210,
      currentIndex: 1,
      total: 0,
    }
  },
  mounted() {
    this.loadData(1);
  },
  methods: {
    loadData(index){
      let params = {
        pageNo: index,
        pageSize: 15,
        params: this.queryField
      }
      queryShjRedCashout(params).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
      })
    },
    updateAuditStatus(id){
      updateAuditStatus(id).then(res => {
        if (res.data.success) {
          this.$message.success("操作成功")
          this.loadData(1);
        } else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    updateGrantStatus(id){
      updateGrantStatus(id).then(res => {
        if (res.data.success) {
          this.$message.success("操作成功")
          this.loadData(1);
        } else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    updateDiscardStatus(id){
      updateDiscardStatus(id).then(res => {
        if (res.data.success) {
          this.$message.success("操作成功")
          this.loadData(1);
        } else {
          this.$message.error(res.data.error.message);
        }
      })
    },
    reset(){
      this.queryField = {
        cashoutId: "",
        userId: "",
        status: ""
      }
      this.loadData(1);
    },
    formatterStatus(row,column,cellValue){
      let rep = "";
      if(cellValue === 1){
        rep = "待审核";
      }else if(cellValue === 2){
        rep = "已审核";
      }else if(cellValue === 3){
        rep = "已发放";
      }else if(cellValue === 4){
        rep = "作废";
      }
      return rep;
    }
  }
}
</script>

<style scoped>

</style>